import StoreContext from "contexts/StoreContext";
import React, { useState, useContext, useEffect } from "react";
import { Card, Table } from "react-bootstrap";
import { apiService } from "service/ApiService";
import { notificationService } from "service/NotificationService";
import { serverTimesampToNormalDate } from "utils/AppUtils";
import { ClipLoader } from "react-spinners";

import { useTranslation } from "react-i18next";

function TableHistoryOrderProductTable({ modalOpen, tableHistoryId }) {
  const {
    t,
  } = useTranslation();

  const { storeId, setStoreId } = useContext(StoreContext);
  const [data, setData] = useState([]);
  const [showLoader, setShowLoader] = useState(true);

  const getData = async () => {
    setShowLoader(true);
    try {
      const dataResponse = await apiService.get(`api/v1/order-products/store/${storeId}/table-history/${tableHistoryId}`);
      setData(attachCustom(dataResponse));
    } catch (error) {
      console.error("Error fetching data:", error);
      notificationService.notifyWarn(error.message);
    } finally {
      setShowLoader(false);
    }
  };

  const attachCustom = (data) => {
    return data.map((obj) => {
      return {
        ...obj,
        className: obj.cancelledByUser ? "danger" : obj.payedByUser ? "success" : "",
        status:
          !obj.cancelledByUser && !obj.payedByUser ? t("common.labels.openSingular") : obj.cancelledByUser ? t("common.labels.cancelledSingular") : obj.payedByUser ? obj.paymentMethod.name : "",
        user: obj.payedByUser ? obj.payedByUser.name : obj.cancelledByUser ? obj.cancelledByUser.name : obj.order.storeUser.name,
        color: obj.cancelledByUser ? "#8b0000" : obj.payedByUser ? "#63ca00" : "",
      };
    });
  };

  const totals = data
    .filter((row) => !row.cancelledByUser)
    .reduce(
      (acc, row) => ({
        subTotal: acc.subTotal + row.subTotal,
        discount: acc.discount + row.discount,
        total: acc.total + row.total,
      }),
      { subTotal: 0, discount: 0, total: 0 }
    );

  useEffect(() => {
    if (modalOpen && tableHistoryId) getData();
  }, [tableHistoryId]);

  return (
    <Card className="regular-table-with-color">
      <Card.Body className="table-responsive p-0">
        {showLoader ? (
          <div style={{ textAlign: "center", marginTop: "5vh", marginBottom: "5vh" }}>
            <ClipLoader size={50} color={"#ff6fbc"} />
          </div>
        ) : (
          <Table hover>
            <thead>
              <tr>
                <th>ID</th>
                <th>{t("tables.headers.product")}</th>
                <th>{t("tables.headers.quantity")}</th>
                <th>{t("tables.headers.unitPriceEuro")}</th>
                <th>{t("tables.headers.openingEuro")}</th>
                <th>{t("tables.headers.discountsEuro")}</th>
                <th>{t("tables.headers.totalEuro")}</th>
                <th>{t("tables.headers.status")}</th>
                <th>{t("tables.headers.updatedAt")}</th>
                <th>{t("tables.headers.user")}</th>
              </tr>
            </thead>
            <tbody>
              {data.map((row) => (
                <tr key={row.id} className={row.className}>
                  <td>{row.localId}</td>
                  <td>
                    {row.product.name}
                    {row.extra.length > 0 ? (
                      <div style={{ fontSize: "12px" }}>
                        {row.extra
                          .map((extra) =>
                            extra.extraPrefix ? extra.extraPrefix.extra_prefix_name + " " + extra.extra.extra_name : extra.extra.extra_name
                          )
                          .join(", ")}
                      </div>
                    ) : null}

                    {row.comments.length > 0 ? <div style={{ fontSize: "12px", marginTop: "0px" }}>{row.comments}</div> : null}
                  </td>
                  <td>{row.quantity}</td>
                  <td>{row.productPrice.toFixed(2)}</td>
                  <td>{row.subTotal.toFixed(2)}</td>
                  <td>{row.discount.toFixed(2)}</td>
                  <td>{row.total.toFixed(2)}</td>
                  <td style={{ color: row.color }}>{row.status}</td>
                  <td>{serverTimesampToNormalDate(row.localUpdatedAt)}</td>
                  <td>{row.user}</td>
                </tr>
              ))}
              <tr>
                <td colSpan={4} style={{ fontWeight: "bold" }}>{t("tables.headers.totals")}</td>
                <td style={{ fontWeight: "bold" }}>{totals.subTotal.toFixed(2)}</td>
                <td style={{ fontWeight: "bold" }}>{totals.discount.toFixed(2)}</td>
                <td style={{ fontWeight: "bold" }}>{totals.total.toFixed(2)}</td>
                <td colSpan={3}></td>
              </tr>
            </tbody>
          </Table>
        )}
      </Card.Body>
    </Card>
  );
}

export default TableHistoryOrderProductTable;
